import Colors from '../../../../shared/assets/style/default/color';
import Props from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const FloatingMenuItem = styled.div<Props>`
  align-items: center;
  background: ${(props) =>
    props.focused ? Colors['button']['floatingMenu'] : ''};
  border: ${Colors['border']['floatingMenu']};
  border-radius: ${40 * Screen.widthRatio}px;
  color: ${(props) => (props.focused ? Colors['dark'] : Colors['text'])};
  display: flex;
  flex-direction: row;
  height: ${64 * Screen.widthRatio}px;
  margin: ${8 * Screen.widthRatio}px;
  padding-right: ${29 * Screen.widthRatio}px;
`;

export default FloatingMenuItem;
